import * as TYPES from './personal-contacts-actiontypes';

export const personalContactsLoaded = (personalContacts) => ({
  type: TYPES.PERSONAL_CONTACTS_LOADED_SUCCESS,
  personalContacts,
});

export const personalContactLoaded = (personalContact) => ({
  type: TYPES.PERSONAL_CONTACT_LOADED_SUCCESS,
  personalContact,
});

export const enabledAccessState = (personalContact) => ({
  type: TYPES.PERSONAL_CONTACTS_ENABLED_ACCESS,
  personalContact,
});

export const disabledAccessState = (personalContact) => ({
  type: TYPES.PERSONAL_CONTACTS_DISABLED_ACCESS,
  personalContact,
});

export const unlockedAccount = () => ({
  type: TYPES.PERSONAL_CONTACTS_UNLOCKED_ACCOUNT,
});

export const resetContactPassword = () => ({
  type: TYPES.PERSONAL_CONTACTS_PASSWORD_RESET,
});

export const clearFlags = () => ({
  type: TYPES.PERSONAL_CONTACTS_CLEAR_FLAGS,
});

export const setPersonalContactId = (contactId) => ({
  type: TYPES.PERSONAL_CONTACTS_SET_CONTACTID,
  selectedContactId: contactId,
});
